<template>
  <b-sidebar :id="'sidebar-language-captions-' + recording.id" :title="'Seleccionar idioma'" sidebar-class="bb-offcanvas-panel hidden-overflow"
             bg-variant="white" right backdrop-variant="dark" backdrop shadow>
    <template #default="{ hide }">
      <div class="row form-row" :class="{ 'form-group--error': $v.language.$error }" style="padding: 1.25rem 1.875rem 0;">
        <label class="column col-sm-12 ng-scope form__label"><span class="mandatory-mark" aria-hidden="true">*</span>Idioma de subtitulado</label>
        <div v-if="$v.language.$error" style="color: red;">El idioma de subtitulado es obligatorio</div>
        <b-form-select :id="'lan'" :options="language_options" v-model="language"></b-form-select>
      </div>
    </template>
    <template #footer="{ hide }">
      <div class="save-buttons panel-footer">
        <div class="buttons-2 equal-buttons row">
          <div class="col-sm-6">
            <button class="button secondary cancel-button" style="padding-left: 1.125em; text-align: center;" @click="hide">Cancelar</button>
          </div>
          <div class="col-sm-6">
            <button class="button save-button" style="padding-left: 1.125em; text-align: center;" @click="confirmGenerateCaptions(recording)">Generar</button>
          </div>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close.vue'
import LocationEnterIcon from 'vue-material-design-icons/LocationEnter.vue'
import utilitiesMixin from '../../../mixins/utilitiesMixin'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'LanguageCaptionSelectSidebar',
  components: {CloseIcon, LocationEnterIcon},
  mixins: [utilitiesMixin],
  props: ['classroom', 'recording', 'user'],
  mounted () {
    this.$moment.locale('es')
  },
  data () {
    return {
      language: null,
      language_options: this.languageOptions()
    }
  },
  validations: {
    language: {
      required
    }
  },
  methods: {
    confirmGenerateCaptions (recording) {
      let vueComponent = this
      // CMM: Validación previa al envío de formulario
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      let message = `La generación de subtítulos supone el pago de un servicio a Amazon, por favor haz uso responsable de la herramienta.`
      if (recording.withCaptions !== 1) {
        message = 'Esta grabación ya dispone de subtítulos. ' + message
      }
      this.$confirm(
        {
          title: `Generar subtítulos`,
          message: message,
          button: {
            no: 'No, cancelar',
            yes: 'Sí, generar'
          },
          callback: confirm => {
            if (confirm) {
              this.$root.$emit('bv::toggle::collapse', 'sidebar-language-captions-' + recording.id)
              vueComponent.generateCaptions(recording)
            }
          }
        }
      )
    },
    generateCaptions (recording) {
      let vueComponent = this
      let urlParams = {
        targetSystem: recording.targetSystem,
        language: this.language
      }
      window.axios.post('recordings/' + recording.id + '/captions/', null, {params: urlParams}).then((response) => {
        if (response && response.status === 200) {
          vueComponent.$set(recording, 'withCaptions', 1)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Modals/LanguageCaptionSelectSidebar.vue